import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class TcTpCreationService {
	constructor(private apiService: ApiService) {}

	createTp(tpRuleDetails) {
		const createTrainingPartnerApi =
			environment.smartServiceURL +
			'/api/smart/v1/trainingpartner/registration/rule';
		return this.apiService.post(createTrainingPartnerApi, tpRuleDetails);
	}

	createTc(tcRuleDetails) {
		const createTrainingCenterApi =
			environment.smartServiceURL +
			'/api/smart/v1/trainingcentre/registration/rule';
		return this.apiService.post(createTrainingCenterApi, tcRuleDetails);
	}

	approveTp(details) {
		const createTrainingPartnerApi =
			environment.smartServiceURL +
			'/api/smart/v1/trainingpartner/registration/rule';
		return this.apiService.put(createTrainingPartnerApi, details);
	}

	approveTc(details) {
		const createTrainingCenterApi =
			environment.smartServiceURL +
			'/api/smart/v1/trainingcentre/registration/rule';
		return this.apiService.put(createTrainingCenterApi, details);
	}

	getTpFormDetails({ userName, role }) {
		const url = `${
			environment.smartServiceURL
		}/api/smart/v1/getPendingTPRuleRequests`;
		return this.apiService.get(url);
	}

	getTcFormDetails() {
		const url = `${
			environment.smartServiceURL
		}/api/smart/v1/getPendingTCRuleRequests`;
		return this.apiService.get(url);
	}
}
